import { z } from "zod"
import { type Translator } from "@/features/translations"
import { getNameSchema } from "@/schemas/getNameSchema"

export function getInvoiceUploadSchema(t: Translator<"InvoiceUploadCard">) {
    return z.object({
        givenName: getNameSchema({
            requiredErrorMessage: t("personalInfo.error.givenNameRequired"),
            invalidErrorMessage: t("personalInfo.error.givenNameInvalid"),
        }),
        familyName: getNameSchema({
            requiredErrorMessage: t("personalInfo.error.familyNameRequired"),
            invalidErrorMessage: t("personalInfo.error.familyNameInvalid"),
        }),
        file: z.instanceof(File, { message: t("fileInput.fileRequired") }).nullable(),
    })
}
